"use strict";

exports.__esModule = true;
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireWildcard(require("react"));

var _TableCell = _interopRequireDefault(require("./TableCell"));

var _TableHeaderCell = _interopRequireDefault(require("./TableHeaderCell"));

var _TableContext = _interopRequireDefault(require("./TableContext"));

var _styled = require("./styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TableSelectableCell =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(TableSelectableCell, _Component);

  function TableSelectableCell() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = TableSelectableCell.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return this.props.checked !== nextProps.checked || this.props.indeterminate !== nextProps.indeterminate;
  };

  _proto.render = function render() {
    var _this = this;

    return (0, _core.jsx)(_TableContext.default.Consumer, null, function (_ref) {
      var density = _ref.density;

      var _this$props = _this.props,
          checked = _this$props.checked,
          disabled = _this$props.disabled,
          indeterminate = _this$props.indeterminate,
          isHeader = _this$props.isHeader,
          label = _this$props.label,
          onChange = _this$props.onChange,
          restProps = _objectWithoutPropertiesLoose(_this$props, ["checked", "disabled", "indeterminate", "isHeader", "label", "onChange"]);

      var Root = isHeader ? _TableHeaderCell.default : _TableCell.default;

      var rootProps = _objectSpread({
        noPadding: true,
        width: isHeader ? 1 : undefined
      }, restProps);

      var checkboxProps = {
        checked: checked,
        disabled: disabled,
        density: density,
        hideLabel: true,
        indeterminate: indeterminate,
        isHeader: isHeader,
        label: label,
        onChange: onChange
      };
      return (0, _core.jsx)(Root, rootProps, (0, _core.jsx)(_styled.PaddedCheckbox, checkboxProps));
    });
  };

  return TableSelectableCell;
}(_react.Component);

exports.default = TableSelectableCell;

_defineProperty(TableSelectableCell, "displayName", 'TableSelectableCell');